import React from 'react'
import { CheckboxV2, CheckboxGroup, l } from '@manychat/manyui'

import { FieldType } from 'common/fields/entities/enums'
import UserFieldPicker, {
  UserFieldSelectEvent,
} from 'common/fields/linking/components/UserFieldPicker'
import LabelTooltip from 'components/LabelTooltip'
import { PayPalConfig } from 'shared/api/requests/settings/schemas'

const BuyButtonAdditionalUserData = ({
  button,
  paypal,
  onChange,
}: {
  button: UnsafeAnyObject
  paypal: boolean | PayPalConfig | null
  onChange: (changes: Record<string, string | number | boolean>) => void
}) => {
  const { contact_email, contact_phone, shipping_address, email_field_id } = button
  const values = { contact_email, contact_phone, shipping_address }
  const groupValue = Object.keys(values).filter((key) => values[key as keyof typeof values])

  const handleGroupChange = (selected: string[]) => {
    onChange({
      contact_email: selected.includes('contact_email'),
      contact_phone: selected.includes('contact_phone'),
      shipping_address: selected.includes('shipping_address'),
    })
  }

  const handleSelect = (e: UserFieldSelectEvent) => {
    const { name, value } = e.target
    if (typeof name === 'string') {
      onChange({ [name]: value })
    }
  }

  const body = (
    <>
      <CheckboxGroup name="Contact-info" onChange={handleGroupChange} value={groupValue}>
        <CheckboxV2 value="contact_email" label={l.translate('Email')} disabled />
        <CheckboxV2 value="contact_phone" label={l.translate('Contact Phone Number')} />
        <CheckboxV2 value="shipping_address" label={l.translate('Shipping Address')} />
      </CheckboxGroup>

      <div className="text-black font-semibold m-t">
        {l.translate('Email Field Value for Pre-fill')}
        <LabelTooltip>
          {l.translate(
            'If you have an e-mail Custom Field, you can use it for pre-fill. This setting is not obligatory.',
          )}
        </LabelTooltip>
      </div>
      <div className="m-t-xxs">
        <UserFieldPicker
          allowedTypes={[FieldType.TEXT]}
          name="email_field_id"
          onChange={handleSelect}
          value={email_field_id}
          ariaLabel={l.translate('Email Field Value for Pre-fill')}
        />
      </div>
    </>
  )

  return (
    <div className="d-flex flex-col">
      <label className="popover-form-label">
        {l.translate('Additional Contact Data')}
        <LabelTooltip>
          {l.translate('Additional info you can request from a subscriber')}
        </LabelTooltip>
      </label>

      {paypal && (
        <div className="panel panel-info d-flex flex-col justify-between">
          <div className="b-b p-a">
            {l.translate(
              'These settings are available only for Stripe Payments. <b>PayPal doesn’t provide this information.</b>',
            )}
          </div>

          <div className="p-a d-flex flex-col">{body}</div>
        </div>
      )}

      {!paypal && body}
    </div>
  )
}

export default BuyButtonAdditionalUserData
